/*
 * Routed Component
 */
(function () {

    'use strict';

    var task = {
        templateUrl: 'app/entities/shared/task/task.html',
        bindings: {
            onResolveDisabled: '&',   // [UI-VIEW.ATTR]
            onResolveProperties: '&', // [UI-VIEW.ATTR] this is how child state return possible properties to parent
            properties: '<',          // [THIS.RESOLVE] passed in from state.resolve
            propertyId: '<',          // [PARENT.RESOLVE] user selection
            account: '<',
            returnTo: '<',
            tasks: '<',
            taskDate: '<',
            // $transition$: '<',
        },
        controller: 'TaskController',
    }

    angular
        .module('tyallsApp')
        .component('task', task)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.task', {
                    // url: '/{date}',
                    views: {
                        'prop@^': 'task',
                    },
                    params: {
                        date: null,
                        returnTo: null,
                        tasks: null,
                    }, // non-url params
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForUser()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                        returnTo: ['$transition$', function ($transition$) {
                            return $transition$.params().returnTo;
                        }],
                        tasks: ['$transition$', function ($transition$) {
                            return $transition$.params().tasks;
                        }],
                        taskDate: ['$transition$', function ($transition$) {
                            return $transition$.params().date;
                        }],
                    },
                    data: {
                        authorities: [],
                        pageTitle: 'Task-Day'
                    },

                });
        }])
})();
